import React, {PureComponent} from 'react'
import {connect} from 'react-redux'

import Header from "../../components/Headers/Header";
import {Button, Card, CardBody, CardHeader, Container, FormGroup, Input, Row} from "reactstrap";
import Col from "react-bootstrap/Col";
import {Translate, withLocalize} from "react-localize-redux";
import "./file.css";

import * as Roles from "../../store/actions/roles";

import italianFilePlickDetailTranslations from "../../translations/file/detail/it.file.detail.json";
import englishFilePlickDetailTranslations from "../../translations/file/detail/en.file.detail.json";
import * as actions from "../../store/actions/actions";

class PlickDetail extends PureComponent {
    constructor(props) {
        super(props);

        this.props.addTranslationForLanguage(italianFilePlickDetailTranslations, "it");
        this.props.addTranslationForLanguage(englishFilePlickDetailTranslations, "en");
    }

    onTransactionIdChange = (event) => {
        let TransactionId = event.target.value
        this.props.transactionIdChange(TransactionId)
    }

    onSenderIdChange = (event) => {
        let senderId = event.target.value
        this.props.senderIdChange(senderId)
    }

    onSenderFirstnameChange = (event) => {
        let senderFirstname = event.target.value
        this.props.senderFirstnameChange(senderFirstname)
    }

    onSenderLastnameChange = (event) => {
        let senderLastname = event.target.value
        this.props.senderLastnameChange(senderLastname)
    }

    onSenderIsCompanyChange = (event) => {
        let senderIsCompany = event.target.value
        this.props.senderIsCompanyChange(senderIsCompany)
    }

    onSenderCompanyChange = (event) => {
        let senderCompany = event.target.value
        this.props.senderCompanyChange(senderCompany)
    }

    onSenderDeviceChange = (event) => {
        let senderDevice = event.target.value
        this.props.senderDeviceChange(senderDevice)
    }

    onSenderAccountChange = (event) => {
        let senderAccount = event.target.value
        this.props.senderAccountChange(senderAccount)
    }

    onSenderLanguagePreferencesChange = (event) => {
        let senderLanguagePreferences = event.target.value
        this.props.senderLanguagePreferencesChange(senderLanguagePreferences)
    }

    onSenderExtraInfoChange = (event) => {
        let senderExtraInfo = event.target.value
        this.props.senderExtraInfoChange(senderExtraInfo)
    }

    onReceiverNameChange = (event) => {
        let receiverName = event.target.value
        this.props.receiverNameChange(receiverName)
    }

    onReceiverDeviceChange = (event) => {
        let receiverDevice = event.target.value
        this.props.receiverDeviceChange(receiverDevice)
    }

    onReceiverIbanChange = (event) => {
        let receiverIban = event.target.value
        this.props.receiverIbanChange(receiverIban)
    }

    onReceiverIbanFromBankChange = (event) => {
        let receiverIbanFromBank = event.target.value
        this.props.receiverIbanFromBankChange(receiverIbanFromBank)
    }

    onIdBankChange = (event) => {
        let idBank = event.target.value
        this.props.idBankChange(idBank)
    }

    onActivationDateChange = (event) => {
        let activationDate = event.target.value
        this.props.activationDateChange(activationDate)
    }

    onAmountStringChange = (event) => {
        let amountString = event.target.value
        this.props.amountStringChange(amountString)
    }

    onCausalChange = (event) => {
        let causal = event.target.value
        this.props.causalChange(causal)
    }

    onNotesChange = (event) => {
        let notes = event.target.value
        this.props.notesChange(notes)
    }

    onPinChange = (event) => {
        let pin = event.target.value
        this.props.pinChange(pin)
    }

    onPinTypeChange = (event) => {
        let pinType = event.target.value
        this.props.pinTypeChange(pinType)
    }

    onIdLogoChange = (event) => {
        let idLogo = event.target.value
        this.props.idLogoChange(idLogo)
    }

    onReceiverLanguagePreferencesChange = (event) => {
        let receiverLanguagePreferences = event.target.value
        this.props.receiverLanguagePreferencesChange(receiverLanguagePreferences)
    }

    onCorrectPlickChange = (event) => {
        let correctPlick = event.target.value
        this.props.correctPlickChange(correctPlick)
    }

    onPlickIdFromPortalChange = (event) => {
        let plickIdFromPortal = event.target.value
        this.props.plickIdFromPortalChange(plickIdFromPortal)
    }

    onPlickTypeChange = (event) => {
        let plickType = event.target.value
        this.props.plickTypeChange(plickType)
    }

    onReceiverTypeChange = (event) => {
        let receiverType = event.target.value
        this.props.receiverTypeChange(receiverType)
    }

    onBankCroChange = (event) => {
        let bankCro = event.target.value
        this.props.bankCroChange(bankCro)
    }

    onBankExecutionDateChange = (event) => {
        let bankExecutionDate = event.target.value
        this.props.bankExecutionDateChange(bankExecutionDate)
    }

    onCurrencyDateChange = (event) => {
        let currencyDate = event.target.value
        this.props.currencyDateChange(currencyDate)
    }

    onTransferStatusChange = (event) => {
        let transferStatus = event.target.value
        this.props.transferStatusChange(transferStatus)
    }

    onBackClick = () => {
        this.props.history.goBack();
    }

    submitHandler = (event) => {
        event.preventDefault();
        this.props.updatePlick(this.props.plickDetail)
    }

    render() {
        let errors = "";
        errors = this.props.validationErrorsList;
        let transactionId = '';
        let senderId = '';
        let senderIsCompany = '';
        let senderCompany = '';
        let senderDevice = '';
        let senderAccount = '';
        let senderLanguagePreferences = '';
        let senderExtraInfo = '';
        let receiverName = '';
        let receiverDevice = '';
        let receiverIban = '';
        let receiverIbanFromBank = '';
        let activationDate = '';
        let amountString = '';
        let causal = '';
        let notes = '';
        let pin = '';
        let pinType = '';

        let senderFirstname = '';
        let senderLastname = '';
        let idBank = '';
        let idLogo = '';
        let receiverLanguagePreferences = '';
        let correctPlick = '';
        let plickIdFromPortal = '';
        let plickType = '';
        let receiverType = '';
        let bankCro = '';
        let bankExecutionDate = '';
        let currencyDate = '';
        let transferStatus = '';

        let allowedEdit = Roles.checkEdit(this.props.role);

        if (errors !== null && errors !== "" && errors !== undefined) {
            if (errors.length > 0) {
                errors.map((item) => {
                    if (item.field === 'transactionId') {
                        transactionId = item.defaultMessage;
                    }
                    if (item.field === 'senderId') {
                        senderId = item.defaultMessage;
                    }
                    if (item.field === 'senderCompany') {
                        senderCompany = item.defaultMessage;
                    }
                    if (item.field === 'senderIsCompany') {
                        senderIsCompany = item.defaultMessage;
                    }
                    if (item.field === 'senderDevice') {
                        senderDevice = item.defaultMessage;
                    }
                    if (item.field === 'senderAccount') {
                        senderAccount = item.defaultMessage;
                    }
                    if (item.field === 'senderLanguagePreferences') {
                        senderLanguagePreferences = item.defaultMessage;
                    }
                    if (item.field === 'senderExtraInfo') {
                        senderExtraInfo = item.defaultMessage;
                    }
                    if (item.field === 'receiverName') {
                        receiverName = item.defaultMessage;
                    }
                    if (item.field === 'receiverDevice') {
                        receiverDevice = item.defaultMessage;
                    }
                    if (item.field === 'receiverIban') {
                        receiverIban = item.defaultMessage;
                    }
                    if (item.field === 'receiverIbanFromBank') {
                        receiverIbanFromBank = item.defaultMessage;
                    }
                    if (item.field === 'activationDate') {
                        activationDate = item.defaultMessage;
                    }
                    if (item.field === 'amountString') {
                        amountString = item.defaultMessage;
                    }
                    if (item.field === 'causal') {
                        causal = item.defaultMessage;
                    }
                    if (item.field === 'notes') {
                        notes = item.defaultMessage;
                    }
                    if (item.field === 'pin') {
                        pin = item.defaultMessage;
                    }
                    if (item.field === 'pinType') {
                        pinType = item.defaultMessage;
                    }
                    if (item.field === 'senderFirstname') {
                        senderFirstname = item.defaultMessage;
                    }
                    if (item.field === 'senderLastname') {
                        senderLastname = item.defaultMessage;
                    }
                    if (item.field === 'idBank') {
                        idBank = item.defaultMessage;
                    }
                    if (item.field === 'idLogo') {
                        idLogo = item.defaultMessage;
                    }
                    if (item.field === 'receiverLanguagePreferences') {
                        receiverLanguagePreferences = item.defaultMessage;
                    }
                    if (item.field === 'correctPlick') {
                        correctPlick = item.defaultMessage;
                    }
                    if (item.field === 'plickIdFromPortal') {
                        plickIdFromPortal = item.defaultMessage;
                    }
                    if (item.field === 'plickType') {
                        plickType = item.defaultMessage;
                    }
                    if (item.field === 'receiverType') {
                        receiverType = item.defaultMessage;
                    }
                    if (item.field === 'bankCro') {
                        bankCro = item.defaultMessage;
                    }
                    if (item.field === 'bankExecutionDate') {
                        bankExecutionDate = item.defaultMessage;
                    }
                    if (item.field === 'currencyDate') {
                        currencyDate = item.defaultMessage;
                    }
                    if (item.field === 'transferStatus') {
                        transferStatus = item.defaultMessage;
                    }
                    return ""
                });
            }
        }

        return (
            <>
                <Header/>
                <Container className="mt--5" fluid>
                    <Row>
                        <div className="col" style={{paddingBottom: "2%"}}>
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <Row>
                                        <div className="col">
                                            <h3 className="mb-0">
                                                <Translate id="plick.detail.title" data={{transactionId: this.props.transactionId}}/>
                                            </h3>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <form onSubmit={this.submitHandler}>
                                        <div className="align-items-center table-flush">
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="transactionId">
                                                            <Translate id="plick.detail.transactionId"/>
                                                        </label>
                                                        <Input disabled={(transactionId.length > 0 && allowedEdit === true) ? false : true}
                                                               onChange={this.onTransactionIdChange}
                                                               className={transactionId.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                               value={this.props.transactionId}/>
                                                            {transactionId.length > 0 ? <label style={{color: "red"}}><Translate id={transactionId}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="senderId">
                                                            <Translate id="plick.detail.sender.id"/>
                                                        </label>
                                                        <Input disabled={(senderId.length > 0 && allowedEdit === true) ? false : true}
                                                               onChange={this.onSenderIdChange}
                                                               className={senderId.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                               value={this.props.senderId}/>
                                                            {senderId.length > 0 ? <label style={{color: "red"}}><Translate id={senderId}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="senderFirstname">
                                                            <Translate id="plick.detail.senderFirstname"/>
                                                        </label>
                                                        <Input disabled={(senderFirstname.length > 0 && allowedEdit === true) ? false : true}
                                                               onChange={this.onSenderFirstnameChange}
                                                               className={senderFirstname.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                               value={this.props.senderFirstname}/>
                                                            {senderFirstname.length > 0 ? <label style={{color: "red"}}><Translate id={senderFirstname}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="senderLastname">
                                                            <Translate id="plick.detail.senderLastname"/>
                                                        </label>
                                                        <Input
                                                            disabled={(senderLastname.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onSenderLastnameChange}
                                                            className={senderLastname.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.senderLastname}/>
                                                        {senderLastname.length > 0 ? <label style={{color: "red"}}><Translate id={senderLastname}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="senderIsCompany">
                                                            <Translate id="plick.detail.senderIsCompany"/>
                                                        </label>
                                                        <Input
                                                            disabled={(senderIsCompany.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onSenderIsCompanyChange}
                                                            className={senderIsCompany.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.senderIsCompany}/>
                                                        {senderIsCompany.length > 0 ? <label style={{color: "red"}}><Translate id={senderIsCompany}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="senderCompany">
                                                            <Translate id="plick.detail.senderCompany"/>
                                                        </label>
                                                        <Input
                                                            disabled={(senderCompany.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onSenderCompanyChange}
                                                            className={senderCompany.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.senderCompany}/>
                                                        {senderCompany.length > 0 ? <label style={{color: "red"}}><Translate id={senderCompany}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="senderDevice">
                                                            <Translate id="plick.detail.senderDevice"/>
                                                        </label>
                                                        <Input
                                                            disabled={(senderDevice.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onSenderDeviceChange}
                                                            className={senderDevice.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.senderDevice}/>
                                                        {senderDevice.length > 0 ? <label style={{color: "red"}}><Translate id={senderDevice}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="senderAccount">
                                                            <Translate id="plick.detail.senderAccount"/>
                                                        </label>
                                                        <Input
                                                            disabled={(senderAccount.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onSenderAccountChange}
                                                            className={senderAccount.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.senderAccount}/>
                                                        {senderAccount.length > 0 ? <label style={{color: "red"}}><Translate id={senderAccount}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label"
                                                               htmlFor="senderLanguagePreferences">
                                                            <Translate id="plick.detail.senderLanguagePreferences"/>
                                                        </label>
                                                        <Input
                                                            disabled={(senderLanguagePreferences.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onSenderLanguagePreferencesChange}
                                                            className={senderLanguagePreferences.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.senderLanguagePreferences}/>
                                                        {senderLanguagePreferences.length > 0 ? <label style={{color: "red"}}><Translate id={senderLanguagePreferences}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="senderExtraInfo">
                                                            <Translate id="plick.detail.senderExtraInfo"/>
                                                        </label>
                                                        <Input
                                                            disabled={(senderExtraInfo.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onSenderExtraInfoChange}
                                                            className={senderExtraInfo.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={JSON.stringify(this.props.senderExtraInfo).replaceAll("\"", "").replaceAll("{", "").replaceAll("}", "")}/>
                                                        {senderExtraInfo.length > 0 ? <label style={{color: "red"}}><Translate id={senderExtraInfo}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="receiverName">
                                                            <Translate id="plick.detail.receiverName"/>
                                                        </label>
                                                        <Input
                                                            disabled={(receiverName.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onReceiverNameChange}
                                                            className={receiverName.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.receiverName}/>
                                                        {receiverName.length > 0 ? <label style={{color: "red"}}><Translate id={receiverName}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="receiverDevice">
                                                            <Translate id="plick.detail.receiverDevice"/>
                                                        </label>
                                                        <Input
                                                            disabled={(receiverDevice.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onReceiverDeviceChange}
                                                            className={receiverDevice.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.receiverDevice}/>
                                                        {receiverDevice.length > 0 ? <label style={{color: "red"}}><Translate id={receiverDevice}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="receiverIban">
                                                            <Translate id="plick.detail.receiverIban"/>
                                                        </label>
                                                        <Input
                                                            disabled={(receiverIban.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onReceiverIbanChange}
                                                            className={receiverIban.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.receiverIban}/>
                                                        {receiverIban.length > 0 ? <label style={{color: "red"}}><Translate id={receiverIban}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label"
                                                               htmlFor="receiverIbanFromBank">
                                                            <Translate id="plick.detail.receiverIbanFromBank"/>
                                                        </label>
                                                        <Input
                                                            disabled={(receiverIbanFromBank.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onReceiverIbanFromBankChange}
                                                            className={receiverIbanFromBank.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.receiverIbanFromBank}/>
                                                        {receiverIbanFromBank.length > 0 ? <label style={{color: "red"}}><Translate id={receiverIbanFromBank}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="idBank">
                                                            <Translate id="plick.detail.idBank"/>
                                                        </label>
                                                        <Input
                                                            disabled={(idBank.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onIdBankChange}
                                                            className={idBank.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.idBank}/>
                                                        {idBank.length > 0 ? <label style={{color: "red"}}><Translate id={idBank}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="activationDate">
                                                            <Translate id="plick.detail.activationDate"/>
                                                        </label>
                                                        <Input
                                                            disabled={(activationDate.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onActivationDateChange}
                                                            className={activationDate.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.activationDate}/>
                                                        {activationDate.length > 0 ? <label style={{color: "red"}}><Translate id={activationDate}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="amountString">
                                                            <Translate id="plick.detail.amount"/>
                                                        </label>
                                                        <Input
                                                            disabled={(amountString.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onAmountStringChange}
                                                            className={amountString.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.amountString}/>
                                                        {amountString.length > 0 ? <label style={{color: "red"}}><Translate id={amountString}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="causal">
                                                            <Translate id="plick.detail.causal"/>
                                                        </label>
                                                        <Input
                                                            disabled={(causal.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onCausalChange}
                                                            className={causal.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.causal}/>
                                                        {causal.length > 0 ? <label style={{color: "red"}}><Translate id={causal}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="notes">
                                                            <Translate id="plick.detail.notes"/>
                                                        </label>
                                                        <Input
                                                            disabled={(notes.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onNotesChange}
                                                            className={notes.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.notes}/>
                                                        {notes.length > 0 ? <label style={{color: "red"}}><Translate id={notes}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="pin">
                                                            <Translate id="plick.detail.pin"/>
                                                        </label>
                                                        <Input
                                                            disabled={(pin.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onPinChange}
                                                            className={pin.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.pin}/>
                                                        {pin.length > 0 ? <label style={{color: "red"}}><Translate id={pin}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="pinType">
                                                            <Translate id="plick.detail.pinType"/>
                                                        </label>
                                                        <Input
                                                            disabled={(pinType.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onPinTypeChange}
                                                            className={pinType.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.pinType}/>
                                                        {pinType.length > 0 ? <label style={{color: "red"}}><Translate id={pinType}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="idLogo">
                                                            <Translate id="plick.detail.idLogo"/>
                                                        </label>
                                                        <Input
                                                            disabled={(idLogo.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onIdLogoChange}
                                                            className={idLogo.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.idLogo}/>
                                                        {idLogo.length > 0 ? <label style={{color: "red"}}><Translate id={idLogo}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label"
                                                               htmlFor="receiverLanguagePreferences">
                                                            <Translate id="plick.detail.receiverLanguagePreferences"/>
                                                        </label>
                                                        <Input
                                                            disabled={(receiverLanguagePreferences.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onReceiverLanguagePreferencesChange}
                                                            className={receiverLanguagePreferences.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.receiverLanguagePreferences}/>
                                                        {receiverLanguagePreferences.length > 0 ? <label style={{color: "red"}}><Translate id={receiverLanguagePreferences}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="correctPlick">
                                                            <Translate id="plick.detail.correctPlick"/>
                                                        </label>
                                                        <Input
                                                            disabled={(correctPlick.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onCorrectPlickChange}
                                                            className={correctPlick.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.correctPlick}/>
                                                        {correctPlick.length > 0 ? <label style={{color: "red"}}><Translate id={correctPlick}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label"
                                                               htmlFor="plickIdFromPortal">
                                                            <Translate id="plick.detail.plickIdFromPortal"/>
                                                        </label>
                                                        <Input
                                                            disabled={(plickIdFromPortal.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onPlickIdFromPortalChange}
                                                            className={plickIdFromPortal.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.plickIdFromPortal}/>
                                                        {plickIdFromPortal.length > 0 ? <label style={{color: "red"}}><Translate id={plickIdFromPortal}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="plickType">
                                                            <Translate id="plick.detail.plickType"/>
                                                        </label>
                                                        <Input
                                                            disabled={(plickType.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onPlickTypeChange}
                                                            className={plickType.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.plickType}/>
                                                        {plickType.length > 0 ? <label style={{color: "red"}}><Translate id={plickType}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="receiverType">
                                                            <Translate id="plick.detail.receiverType"/>
                                                        </label>
                                                        <Input
                                                            disabled={(receiverType.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onReceiverTypeChange}
                                                            className={plickIdFromPortal.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.receiverType}/>
                                                        {receiverType.length > 0 ? <label style={{color: "red"}}><Translate id={receiverType}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="bankCro">
                                                            <Translate id="plick.detail.bankCro"/>
                                                        </label>
                                                        <Input
                                                            disabled={(bankCro.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onBankCroChange}
                                                            className={bankCro.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.bankCro}/>
                                                        {bankCro.length > 0 ? <label style={{color: "red"}}><Translate id={bankCro}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label"
                                                               htmlFor="bankExecutionDate">
                                                            <Translate id="plick.detail.bankExecutionDate"/>
                                                        </label>
                                                        <Input
                                                            disabled={(bankExecutionDate.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onBankExecutionDateChange}
                                                            className={plickIdFromPortal.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.bankExecutionDate}/>
                                                        {bankExecutionDate.length > 0 ?
                                                            <label style={{color: "red"}}><Translate id={bankExecutionDate}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="currencyDate">
                                                            <Translate id="plick.detail.currencyDate"/>
                                                        </label>
                                                        <Input
                                                            disabled={(currencyDate.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onCurrencyDateChange}
                                                            className={currencyDate.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.currencyDate}/>
                                                        {currencyDate.length > 0 ? <label style={{color: "red"}}><Translate id={currencyDate}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="transferStatus">
                                                            <Translate id="plick.detail.transferStatus"/>
                                                        </label>
                                                        <Input
                                                            disabled={(transferStatus.length > 0 && allowedEdit === true) ? false : true}
                                                            onChange={this.onTransferStatusChange}
                                                            className={transferStatus.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative'}
                                                            value={this.props.transferStatus}/>
                                                        {transferStatus.length > 0 ? <label style={{color: "red"}}><Translate id={transferStatus}/></label> : ""}
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <Row style={{paddingTop: "2%"}}>
                                                <Col align="left">
                                                    <Button onClick={this.onBackClick} variant="contained">
                                                        <i className="fas fa-arrow-left text-primary"/>
                                                    </Button>
                                                </Col>
                                                {(allowedEdit === true && this.props.correctPlick === false) ?
                                                    <Col align={"right"}>
                                                        <Button className="btn-success" type="submit"
                                                                variant="contained">
                                                            <Translate id="plick.detail.update"/>
                                                        </Button>
                                                    </Col> : ""
                                                }
                                            </Row>
                                        </div>
                                    </form>
                                </CardBody>
                            </Card>
                        </div>
                    </Row>
                </Container>
            </>

        );
    }
}

const mapStateToProps = state => {
    return {
        plickDetail: state.plickDetail.plickDetail,
        role: state.authentication.authenticatedUser.role,
        id: state.plickDetail.plickDetail.id,
        fileId: state.plickDetail.plickDetail.fileId,
        transactionId: state.plickDetail.plickDetail.transactionId,
        senderId: state.plickDetail.plickDetail.senderId,
        senderFirstname: state.plickDetail.plickDetail.senderFirstname,
        senderLastname: state.plickDetail.plickDetail.senderLastname,
        senderIsCompany: state.plickDetail.plickDetail.senderIsCompany,
        senderCompany: state.plickDetail.plickDetail.senderCompany,
        senderDevice: state.plickDetail.plickDetail.senderDevice,
        senderAccount: state.plickDetail.plickDetail.senderAccount,
        senderLanguagePreferences: state.plickDetail.plickDetail.senderLanguagePreferences,
        senderExtraInfo: state.plickDetail.plickDetail.senderExtraInfo,
        receiverName: state.plickDetail.plickDetail.receiverName,
        receiverDevice: state.plickDetail.plickDetail.receiverDevice,
        receiverIban: state.plickDetail.plickDetail.receiverIban,
        receiverIbanFromBank: state.plickDetail.plickDetail.receiverIbanFromBank,
        idBank: state.plickDetail.plickDetail.idBank,
        activationDate: state.plickDetail.plickDetail.activationDate,
        amount: state.plickDetail.plickDetail.amount,
        amountString: state.plickDetail.plickDetail.amountString,
        causal: state.plickDetail.plickDetail.causal,
        notes: state.plickDetail.plickDetail.notes,
        pin: state.plickDetail.plickDetail.pin,
        pinType: state.plickDetail.plickDetail.pinType,
        idLogo: state.plickDetail.plickDetail.idLogo,
        correctPlickreceiverLanguagePreferences: state.plickDetail.plickDetail.receiverLanguagePreferences,
        correctPlick: state.plickDetail.plickDetail.correctPlick,
        plickIdFromPortal: state.plickDetail.plickDetail.plickIdFromPortal,
        plickType: state.plickDetail.plickDetail.plickType,
        receiverType: state.plickDetail.plickDetail.receiverType,
        bankCro: state.plickDetail.plickDetail.bankCro,
        bankExecutionDate: state.plickDetail.plickDetail.bankExecutionDate,
        currencyDate: state.plickDetail.plickDetail.currencyDate,
        transferStatus: state.plickDetail.plickDetail.transferStatus,
        validationErrorsList: state.plickDetail.plickDetail.validationErrorsList
    }
}

const mapDispatchToProps = dispatch => {
    return {
        transactionIdChange: (transactionId) => dispatch({type: actions.PLICK_DETAIL_TRANSACTION_ID_FIELD_CHANGE_REQUEST, value: transactionId}),
        senderIdChange: (senderId) => dispatch({type: actions.PLICK_DETAIL_SENDER_ID_FIELD_CHANGE_REQUEST, value: senderId}),
        senderFirstnameChange: (senderFirstname) => dispatch({type: actions.PLICK_DETAIL_SENDER_FIRST_NAME_FIELD_CHANGE_REQUEST, value: senderFirstname}),
        senderLastnameChange: (senderLastname) => dispatch({type: actions.PLICK_DETAIL_SENDER_LAST_NAME_FIELD_CHANGE_REQUEST, value: senderLastname}),
        senderIsCompanyChange: (senderIsCompany) => dispatch({type: actions.PLICK_DETAIL_SENDER_IS_COMPANY_FIELD_CHANGE_REQUEST, value: senderIsCompany}),
        senderCompanyChange: (senderCompany) => dispatch({type: actions.PLICK_DETAIL_SENDER_COMPANY_FIELD_CHANGE, value: senderCompany}),
        senderDeviceChange: (senderDevice) => dispatch({type: actions.PLICK_DETAIL_SENDER_DEVICE_FIELD_CHANGE_REQUEST, value: senderDevice}),
        senderAccountChange: (senderAccount) => dispatch({type: actions.PLICK_DETAIL_SENDER_ACCOUNT_FIELD_CHANGE_REQUEST, value: senderAccount}),
        senderLanguagePreferencesChange: (senderLanguagePreferences) => dispatch({type: actions.PLICK_DETAIL_SENDER_LANGUAGE_PREFERENCES_FIELD_CHANGE_REQUEST, value: senderLanguagePreferences}),
        senderExtraInfoChange: (senderExtraInfo) => dispatch({type: actions.PLICK_DETAIL_SENDER_EXTRA_INFO_FIELD_CHANGE_REQUEST, value: senderExtraInfo}),
        receiverNameChange: (receiverName) => dispatch({type: actions.PLICK_DETAIL_RECEIVER_NAME_FIELD_CHANGE_REQUEST, value: receiverName}),
        receiverDeviceChange: (receiverDevice) => dispatch({type: actions.PLICK_DETAIL_RECEIVER_DEVICE_FIELD_CHANGE_REQUEST, value: receiverDevice}),
        receiverIbanChange: (receiverIban) => dispatch({type: actions.PLICK_DETAIL_RECEIVER_IBAN_FIELD_CHANGE_REQUEST, value: receiverIban}),
        receiverIbanFromBankChange: (receiverIbanFromBank) => dispatch({type: actions.PLICK_DETAIL_RECEIVER_IBAN_FROM_BANK_FIELD_CHANGE_REQUEST, value: receiverIbanFromBank}),
        idBankChange: (idBank) => dispatch({type: actions.PLICK_DETAIL_ID_BANK_FIELD_CHANGE_REQUEST, value: idBank}),
        activationDateChange: (dateChange) => dispatch({type: actions.PLICK_DETAIL_ACTIVATION_DATE_FIELD_CHANGE_REQUEST, value: dateChange}),
        amountStringChange: (amountString) => dispatch({type: actions.PLICK_DETAIL_AMOUNT_STRING_FIELD_CHANGE_REQUEST, value: amountString}),
        causalChange: (causal) => dispatch({type: actions.PLICK_DETAIL_CAUSAL_FIELD_CHANGE_REQUEST, value: causal}),
        notesChange: (notes) => dispatch({type: actions.PLICK_DETAIL_NOTES_FIELD_CHANGE_REQUEST, value: notes}),
        pinChange: (pin) => dispatch({type: actions.PLICK_DETAIL_PIN_FIELD_CHANGE_REQUEST, value: pin}),
        pinTypeChange: (pinType) => dispatch({type: actions.PLICK_DETAIL_PIN_TYPE_FIELD_CHANGE_REQUEST, value: pinType}),
        idLogoChange: (idLogo) => dispatch({type: actions.PLICK_DETAIL_ID_LOGO_FIELD_CHANGE_REQUEST, value: idLogo}),
        receiverLanguagePreferencesChange: (receiverLanguagePreferences) => dispatch({type: actions.PLICK_DETAIL_RECEIVER_LANGUAGE_PREFERENCES_FIELD_CHANGE_REQUEST, value: receiverLanguagePreferences}),
        correctPlickChange: (correctPlick) => dispatch({type: actions.PLICK_DETAIL_CORRECT_PLICK_FIELD_CHANGE_REQUEST, value: correctPlick}),
        plickIdFromPortalChange: (plickIdFromPortal) => dispatch({type: actions.PLICK_DETAIL_PLICK_ID_FROM_PORTAL_FIELD_CHANGE_REQUEST, value: plickIdFromPortal}),
        plickTypeChange: (plickType) => dispatch({type: actions.PLICK_DETAIL_PLICK_TYPE_FIELD_CHANGE_REQUEST, value: plickType}),
        receiverTypeChange: (receiverType) => dispatch({type: actions.PLICK_DETAIL_RECEIVER_TYPE_FIELD_CHANGE_REQUEST, value: receiverType}),
        bankCroChange: (bankCro) => dispatch({type: actions.PLICK_DETAIL_BANK_CRO_FIELD_CHANGE_REQUEST, value: bankCro}),
        bankExecutionDateChange: (bankExecutionDate) => dispatch({type: actions.PLICK_DETAIL_BANK_EXECUTION_DATE_FIELD_CHANGE_REQUEST, value: bankExecutionDate}),
        currencyDateChange: (currencyDate) => dispatch({type: actions.PLICK_DETAIL_CURRENCY_DATE_FIELD_CHANGE_REQUEST, value: currencyDate}),
        transferStatusChange: (transferStatus) => dispatch({type: actions.PLICK_DETAIL_TRANSFER_STATUS_FIELD_CHANGE_REQUEST, value: transferStatus}),

        updatePlick: (plickData) => dispatch({type: actions.PLICK_DETAIL_UPDATE_REQUEST, value: plickData})

    };
};

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(PlickDetail));